/**
 * 租户信息
 */
import { defineStore } from 'pinia'

const initState = () => ({
  tenantId: '1', // 租户ID
})

export const useTenantStore = defineStore(
  'tenant',
  () => {
    const tenantData = ref({ ...initState() })
    // 获取状态
    const getTenantData = (key) => {
      if (!(key in tenantData.value)) {
        throw new Error(`属性 "${key}" 在 tenantData.value 中不存在`)
      }
      return tenantData.value[key]
    }

    // 设置状态
    const setTenantData = (key, val) => {
      tenantData.value[key] = val
    }
    const resetState = () => {
      tenantData.value = initState()
    }
    return {
      tenantData,
      resetState,
      getTenantData,
      setTenantData,
    }
  },
  {
    persist: true,
  },
)
